// extracted by mini-css-extract-plugin
export default {"component":"cqwDH","descriptions":"cB0eT"};